module.exports = __webpack_public_path__ + "img/20191015165058096.79e7caa0.jpg";